import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { SecondaryButton } from '@bibliocommons/deprecated-base-buttons';

class CancelHoldButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    this.props.cancelHold(this.props.metadataId);
  }

  render() {
    return (
      <SecondaryButton
        handleClick={this.handleClick}
        block
        className="cp-cancel-hold-button"
        data-test-id={`cancel-hold-${this.props.metadataId}`}
        isLoading={this.props.isLoading}
      >
        <FormattedMessage id="btn.cancelHold" />
      </SecondaryButton>
    );
  }
}

CancelHoldButton.propTypes = {
  cancelHold: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  metadataId: PropTypes.string.isRequired
};

export default CancelHoldButton;
